import React from 'react';
import { Translation } from 'react-i18next';

export const APPS_RESOURCE = 'apps';
export const APP_RESOURCE = 'app';
export const UPDATE_APP_RESOURCE = 'updateApp';
export const REMOVE_APP_RESOURCE = 'removeApp';

export const APP_INSTALLATIONS_RESOURCE = 'appInstallationsOverview';
export const APP_INSTALLATION_RESOURCE = 'appInstallation';
export const UPDATE_APP_INSTALLATION_RESOURCE = 'updateAppInstallation';
export const REMOVE_APP_INSTALLATION_RESOURCE = 'removeAppInstallation';

export const REMOVE_FEATURE_SUBSCRIPTION_RESOURCE = 'removeFeatureSubscription';
export const REMOVE_ROLE_RESOURCE = 'removeRole';
export const REMOVE_FEATURE_RESOURCE = 'removeFeature';

export const INFINITE_SCROLL = { loader: 'blocked' };
export const ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
};

const APP_ACTIVE_STATES = {
  ACTIVE: 1,
  INACTIVE: 2,
};

export const APP_ACTIVE_STATE_OPTIONS = [
  {
    key: APP_ACTIVE_STATES.ACTIVE,
    value: APP_ACTIVE_STATES.ACTIVE,
    text: <Translation>{t => t('active')}</Translation>,
  },
  {
    key: APP_ACTIVE_STATES.INACTIVE,
    value: APP_ACTIVE_STATES.INACTIVE,
    text: <Translation>{t => t('inactive')}</Translation>,
  },
];

export const TABS = {
  DETAILS: 'details',
  INSTALLATIONS: 'installations',
  ORGANISATIONS: 'organisations',
  COMMUNITIES: 'communities',
};

export const FEATURE_TABS = {
  DETAILS: 'details',
  ROLES: 'roles',
  ASSIGNMENTS: 'assignments',
  SUBSCRIPTIONS: 'subscriptions',
  COMMUNITIES: 'communities',
};

export const ROLE_TABS = {
  DETAILS: 'details',
  ASSIGNMENTS: 'assignments',
};
